import { AppState } from "../../../states";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";

import { TechnicianContactsActions } from "../../states/Contacts/TechnicianContactsState";
import { CustomerContactsActions } from "../../states/Contacts/CustomerContactsState";
import { WorkspaceActions, User } from "../../states/WorkspacesState";

import { MessagesActions } from "../../states/Messages/MessagesState";
import { CommunicationMain } from "./Main";

import { Agent } from "../../../models/Agent/Agent";

import { AVALABLE_DEPARTMENTS } from "../../constants";

const departments_list = AVALABLE_DEPARTMENTS.map((it) => it.id);

export interface StateToProps {
  show?: boolean;
  contactType: number;
  departments: any[];
  workspaces: User[];
  agent: Agent;
  selectedWorkspace: User | null;
  hasAccessToWorkspaces: boolean;
  allCustomerIncomingMessages: number;
  allTechIncomingMessages: number;
}

export interface DispatchToProps {
  changeChatVisibility: () => void;
  changeContactType: (type: number) => void;
  loadCustomerContacts: (contacts: any[]) => void;
  loadTechnicianContacts: (contacts: any[]) => void;
  setSelectedWorkspace: (workspace: User | null) => void;
}

const mapStateToProps = (state: AppState): StateToProps => ({
  // @ts-ignore
  contactType: state["call-center"].messages.contactType,
  departments: AVALABLE_DEPARTMENTS, // state['call-center'].crm.departments.filter(it => departments_list.indexOf(it.id) >= 0),

  //
  // TODO: -- Тут нужно перечислить всех агентов с ролью "dsr", чтобы переключаться мд их списками контактов
  // Фильтрануть по принадлежности к депертаментам
  //
  // @ts-ignore
  workspaces: state["call-center"].cmnc_users.users,
  // @ts-ignore
  hasAccessToWorkspaces: state["call-center"].cmnc_users.hasAccess,
  // @ts-ignore
  selectedWorkspace: state["call-center"].cmnc_users.selectedWorkspace,

  agent: state["call-center"].crm.agent,
  allCustomerIncomingMessages:
    // @ts-ignore
    state["call-center"].cmnc_cust_contacts.allCustomerIncomingMessages,
  allTechIncomingMessages:
    // @ts-ignore
    state["call-center"].cmnc_tech_contacts.allTechIncomingMessages,
});

const mapDispatchToProps = (dispatch: Dispatch<any>): DispatchToProps => ({
  changeChatVisibility: bindActionCreators(
    TechnicianContactsActions.changeVisibility,
    dispatch
  ),
  changeContactType: bindActionCreators(
    MessagesActions.changeContactType,
    dispatch
  ),
  loadCustomerContacts: bindActionCreators(
    CustomerContactsActions.loadContacts,
    dispatch
  ),
  loadTechnicianContacts: bindActionCreators(
    TechnicianContactsActions.loadContacts,
    dispatch
  ),
  setSelectedWorkspace: bindActionCreators(
    WorkspaceActions.setSelectedWorkspace,
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(CommunicationMain);
